import React from "react";
import type { FeeTierStatus } from "./FeeTierSheet";
import "./FeeTierOffer.css";
import { t, formatLocale } from "../i18n";
import { T } from "../i18n/T";

// Launch offer on the Tier Level sheet (founder, 1.5.1 #12 — "first 1,500
// talent: 0% commission for 3 months"). While the server says the offer runs,
// the sheet leads with it: the LAUNCH OFFER chip, 100%, the end date, then the
// rung they land on afterwards on its own line. No bar, no road — there is
// nothing to chase while every request is theirs.

/**
 * The offer's last day in the app language ("Jan 8"), or null when no offer
 * runs right now. The server only sends one while it runs; the date check
 * also covers a cached sheet reopened after the end.
 */
export function launchOfferEnds(status: Pick<FeeTierStatus, "launchOffer"> | null | undefined, now = Date.now()): string | null {
  const until = status?.launchOffer?.until ? new Date(status.launchOffer.until) : null;
  if (!until || !(until.getTime() > now)) return null;
  return until.toLocaleDateString(formatLocale(), { month: "short", day: "numeric" });
}

export function FeeTierOfferBody({ status, ends }: { status: FeeTierStatus; ends: string }) {
  const { tier } = status;
  return (
    <div className="ft-sheet">
      <div className="ft-center">
        <span className="ft-offer-chip">{t("feeTierSheet.launchOffer")}</span>
      </div>
      <div className="ft-hero">100%</div>
      <div className="ft-hero-sub">
        <T k="feeTierSheet.ofEveryRequestUntil" vars={{ date: ends }} tags={{ 0: (c) => <b className="ft-offer-date">{c}</b> }} />
      </div>
      <div className="ft-offer-then">
        <div>{t("feeTierSheet.zeroCommissionForYour")}</div>
        <div>
          <T k="feeTierSheet.thenTier" vars={{ name: tier.name, keepPct: tier.keepPct }} tags={{ 0: (c) => <b>{c}</b> }} />
        </div>
      </div>
    </div>
  );
}
